import { Product, ProductLeaf } from "@decocms/apps-commerce/types"
import { useOffer } from "~/sdk/useOffer"

export default function (hasVariant: ProductLeaf[]) {
    const onlyAvailable = hasVariant.filter(
        ({ offers }) => useOffer(offers).availability === 'https://schema.org/InStock',
    )

    return onlyAvailable.reduce((a, b) => {
        const aOffers = useOffer(a.offers)
        const bOffers = useOffer(b.offers)

        const aPrice = aOffers.price ?? 0
        const bPrice = bOffers.price ?? 0

        return bPrice < aPrice || aPrice === 0 ? b : a
    }, onlyAvailable[0]) as Product
}
